<div class="copilot-citations-container" *ngIf="citations?.length">
  <div class="copilot-citations-header">
    <span class="copilot-citations-icon">
      <img [src]="'svg/link.svg' | assetVersion" />
    </span>
    <div class="copilot-citations-title">Sources</div>
  </div>
  <div class="copilot-citations-list">
    <a *ngFor="let citation of citations"
       class="copilot-citation-item"
       [href]="citation.url"
       target="_blank"
       rel="noopener noreferrer">
      <span class="citation-title">{{ citation.title }}</span>
      <span class="citation-domain">{{ getDomain(citation.url) }}</span>
      <span class="citation-snippet">{{ citation.snippet }}</span>
    </a>
  </div>
</div>
